<template>
  <div>
    <vx-card no-shadow>
      <!-- DUPLICATE VENUE TRAINING DIALOG -->
      <vs-prompt
        class="duplicate-event-dialog"
        title="Duplicate Event"
        accept-text="Duplicate Event"
        @accept="duplicateVenueTraining"
        :is-valid="validForm"
        :active.sync="activePromptDuplicateEvent"
      >
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-5/5 w-full" style="display: flex">
            <div>
              <small class="date-label">Start Date</small>
              <flat-pickr
                :config="configdateDuplicateStartTimePicker"
                v-model="duplicateStartDate"
                placeholder="Start..."
                style="display: flex"
              />
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-5/5 w-full" style="display: flex">
            <div>
              <small class="date-label">End Date</small>
              <flat-pickr
                :config="configdateDuplicateEndTimePicker"
                v-model="duplicateEndDate"
                placeholder="End..."
                style="display: flex"
              />
            </div>
          </div>
        </div>
      </vs-prompt>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-2/5 w-full">
          <h2>General</h2>
        </div>

        <div class="vx-col sm:w-3/5 w-full">
          <div class="flex flex-wrap items-center justify-end">
            <vs-button color="success" @click="showDuplicateVenueTrainingDialog" id="save-button" class="ml-auto mt-2"
              >Duplicate Event</vs-button
            >
          </div>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Active</span>
        </div>
        <div class="vx-col">
          <vs-switch color="success" v-if="venueTrainingInstance" v-model="venueTrainingInstance.isActive" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Event Type</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <div class="horizontal-row" v-if="venueTrainingInstance">
            <vs-button
              v-for="venueTrainingType in venueTrainingTypes"
              :key="venueTrainingType.id"
              @click="venueTrainingInstance.venueTrainingType = venueTrainingType.id"
              :color="venueTrainingInstance.venueTrainingType == venueTrainingType.id ? 'success' : 'rgb(80, 80, 80)'"
              :type="venueTrainingInstance.venueTrainingType == venueTrainingType.id ? 'filled' : 'border'"
              icon-pack="feather"
              :icon="venueTrainingInstance.venueTrainingType == venueTrainingType.id ? 'icon-check' : ''"
              class="mr-3 selection-button"
              >{{ venueTrainingType.label }}</vs-button
            >
          </div>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Title</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input class="w-full" v-if="venueTrainingInstance" v-model="venueTrainingInstance.title" />
        </div>
      </div>

      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Description</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <textarea
            class="vs-inputx vs-input--input normal"
            style="height: 200px; font-family: Arial; line-height: 1.5rem"
            spellcheck="false"
            v-if="venueTrainingInstance"
            v-model="venueTrainingInstance.description"
            placeholder="Description..."
          />
        </div>
      </div>

      <vs-divider />

      <div class="vx-row">
        <div class="vx-col sm:w-1/5 w-full">
          <span>When</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full" style="display: flex">
          <div class="my-4">
            <small class="date-label">Start</small>
            <flat-pickr
              v-if="venueTrainingInstance"
              :config="configdateStartTimePicker"
              v-model="startDate"
              placeholder="Start..."
              style="display: flex"
            />
          </div>

          <div class="my-4" style="margin-left: 8px">
            <small class="date-label">End</small>
            <flat-pickr
              v-if="venueTrainingInstance"
              :config="configdateEndTimePicker"
              v-model="endDate"
              placeholder="End..."
              style="display: flex"
            />
          </div>
        </div>
      </div>

      <vs-divider />

      <div class="vx-row mb-6" v-if="venueTrainingInstance && venueTrainingInstance.venueName">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Venue (This is a legacy feature. Use only for reference)</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <p>
            {{ venueTrainingInstance.venueName }}
          </p>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Instructor</span>
        </div>
        <div class="vx-col sm:w-3/5 w-full">
          <TypeAhead
            v-model="data"
            classes="typeahead-container"
            :placeholder="placeholder"
            src=""
            :getResponse="getResponse"
            :selectFirst="selectFirst"
            :limit="parseInt(limit)"
            :queryParamName="queryParamName"
            :minChars="parseInt(minChars)"
            :delayTime="parseInt(delayTime)"
            :onHit="onHit"
            :highlighting="highlighting"
            :render="render"
            :fetch="fetch"
          ></TypeAhead>

          <div v-if="venueTrainingInstance">
            <vs-chip v-if="venueTrainingInstance.instructorId !== null" color="success" class="mt-6 instructor-chip">
              {{ venueTrainingInstance.instructorDisplayName }}
            </vs-chip>
          </div>
        </div>
      </div>

      <vs-divider />

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span><strong>Add general tag</strong></span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <tag-selector :multiple="false" placeholder="Click tag to add" v-on:tag="tagSelected" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span><strong>Add venue tag</strong></span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <venue-selector :multiple="false" placeholder="Click venue to add to tags" v-on:venue="venueSelected" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span
            ><span><code>Selected tags</code></span></span
          >
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-chips v-if="venueTrainingInstance" placeholder="New Tag" v-model="venueTrainingInstance.tags" style="width: 100%">
            <vs-chip color="#24c1a0" :key="tag" @click="removeTag(tag)" v-for="tag in venueTrainingInstance.tags" closable>
              {{ tag }}
            </vs-chip>
          </vs-chips>
          <p style="font-weight: 600; font-size: 85%; margin-top: 8px">
            Campus tag determines the skills users will aquire by completing this event. <br />
            Venue tag determines which venue it will be displayed as in the Campus report.
          </p>
        </div>
      </div>

      <vs-divider />

      <!-- IdamSegmentator section - Audience segmentation -->
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Segmentation (who can see)</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <IdamSegmentator v-model="venueTrainingInstance.userQuery" />
        </div>
      </div>

      <vs-divider />

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Min Participants</span>
        </div>
        <div class="vx-col">
          <vs-input
            v-if="venueTrainingInstance"
            v-validate="'numeric'"
            name="minParticipants"
            v-model="venueTrainingInstance.minParticipants"
            placeholder="Min participants..."
          />
          <div class="text-danger text-sm" v-show="errors.has('minParticipants')">
            {{ errors.first("minParticipants") }}
          </div>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Max Participants</span>
        </div>
        <div class="vx-col">
          <vs-input
            v-if="venueTrainingInstance"
            v-validate="'numeric'"
            name="maxParticipants"
            v-model="venueTrainingInstance.maxParticipants"
            placeholder="Max participants..."
          />
          <div class="text-danger text-sm" v-show="errors.has('maxParticipants')">
            {{ errors.first("maxParticipants") }}
          </div>
        </div>
      </div>

      <vs-divider />

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Notification message</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full" v-if="venueTrainingInstance">
          <vs-input class="w-full" v-model="venueTrainingInstance.notificationMessage" placeholder="48 hours until {title} begins." />
          <p style="font-weight: 600; font-size: 85%; margin-top: 8px">
            Notification will be sent to all participants exactly 2 days prior to the start date.
            <br />
            <span v-if="venueTrainingInstance && venueTrainingInstance.notificationMessage === ''" style="font-weight: 400"
              >Default message preview: "48 hours until {{ venueTrainingInstance.title }} begins."</span
            >
            <span v-if="venueTrainingInstance && venueTrainingInstance.notificationMessage !== ''" style="font-weight: 400"
              >Message preview: "{{ notificationMessagePreview }}"</span
            >
          </p>
        </div>
      </div>

      <vs-divider />

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Survey link (optional)</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input name="surveyLink" class="w-full" v-model="venueTrainingInstance.surveyLink" placeholder="Please enter survey link" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Survey description (optional)</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input
            class="w-full"
            name="surveyDescription"
            v-model="venueTrainingInstance.surveyDescription"
            placeholder="Please enter survey description eg. 'Want to give feedback on this event? click the link below'"
          />
        </div>
      </div>

      <vs-divider />

      <div class="vx-col lg:w-1/1 w-full">
        <h5>Photos &amp; Videos</h5>
      </div>
      <VenueTrainingImages v-if="venueTrainingInstance" :venueTrainingInstance="venueTrainingInstance" style="width: 100%" />

      <!-- Save & Reset Button -->
      <div class="flex flex-wrap items-center justify-end">
        <vs-button @click="saveInfo" id="save-button" class="ml-auto mt-2">Save Changes</vs-button>
      </div>
    </vx-card>

    <vs-divider />

    <vx-card no-shadow>
      <ChangeLog v-if="venueTrainingInstance" :source="filteredChangeLog" />
    </vx-card>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import TypeAhead from "vue2-typeahead";
import VenueSelector from "@/components/Custom/VenueSelector.vue";
import TagSelector from "@/components/TagSelector.vue";
import IdamSegmentator from "@/components/Custom/IdamSegmentator/IdamSegmentator";

const VenueTrainingImages = () => import("./components/VenueTrainingImages.vue");
const ChangeLog = () => import("./../../../../components/change-log/ChangeLog.vue");

export default {
  components: {
    flatPickr,
    VenueSelector,
    TagSelector,
    TypeAhead,
    VenueTrainingImages,
    ChangeLog,
    IdamSegmentator
  },
  props: {
    venueTrainingInstance: Object
  },
  watch: {
    venueTrainingInstance: function (newVal /*, oldVal*/) {
      this.refreshFromInstance(newVal);
    }
  },
  data() {
    let ctx = this;

    return {
      configdateStartTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        dateFormat: "d-m-Y H:i",
        defaultHour: 18,
        defaultMinute: 0,
        defaultSecond: 0,
        onChange: function (selectedDates) {
          if (selectedDates.length === 0) {
            return;
          }

          ctx.updateStartDate(selectedDates[0]);
        }
      },
      configdateEndTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        dateFormat: "d-m-Y H:i",
        defaultHour: 20,
        defaultMinute: 0,
        defaultSecond: 0,
        onChange: function (selectedDates) {
          if (selectedDates.length === 0) {
            return;
          }

          ctx.updateEndDate(selectedDates[0]);
        }
      },
      configdateDuplicateStartTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        dateFormat: "d-m-Y H:i",
        defaultHour: 18,
        defaultMinute: 0,
        defaultSecond: 0,
        onChange: function (selectedDates) {
          if (selectedDates.length === 0) {
            return;
          }

          ctx.updateDuplicateStartDate(selectedDates[0]);
        }
      },
      configdateDuplicateEndTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        dateFormat: "d-m-Y H:i",
        defaultHour: 20,
        defaultMinute: 0,
        defaultSecond: 0,
        onChange: function (selectedDates) {
          if (selectedDates.length === 0) {
            return;
          }

          ctx.updateDuplicateEndDate(selectedDates[0]);
        }
      },

      activePromptDuplicateEvent: false,

      startDate: null,
      localStartDate: null,
      endDate: null,
      localEndDate: null,

      duplicateStartDate: null,
      localDuplicateStartDate: null,

      duplicateEndDate: null,
      localDuplicateEndDate: null,

      // Typeahead
      data: "",
      selectFirst: false,
      limit: 10,
      queryParamName: ":keyword",
      minChars: 2,
      delayTime: 500,
      placeholder: "Please enter Instructor name or email",
      classes: "typeahead",

      venueTrainingTypes: [
        {
          id: 0,
          label: "Regular Event"
        },
        {
          id: 1,
          label: "Masterclass"
        }
      ],

      venueTrainingId: "",
      name: ""
    };
  },
  computed: {
    validForm() {
      return (
        this.localDuplicateStartDate !== "" &&
        this.localDuplicateEndDate !== "" &&
        Date.parse(this.localDuplicateEndDate) - Date.parse(this.localDuplicateStartDate) >= 0
      );
    },
    notificationMessagePreview() {
      return this.venueTrainingInstance.notificationMessage.replace(/{title}/g, this.venueTrainingInstance.title);
    },
    filteredChangeLog() {
      return this.venueTrainingInstance.changeLog.map(e => {
        e.action = e.action.replace("Campus", "Event");
        return e;
      });
    }
  },
  methods: {
    venueSelected(v) {
      //this.venueTrainingInstance.venueName = v.venueName;
      //this.venueTrainingInstance.venueId = v.venueId;
      if (v && v.venueTag) {
        if (!this.venueTrainingInstance.tags.includes(v.venueTag)) this.venueTrainingInstance.tags.push(v.venueTag);
      }

      //console.log("Selected tag", v.venueTag);
      //this.venueTrainingInstance.venue = v;
    },

    tagSelected(tag) {
      if (!this.venueTrainingInstance.tags.includes(tag)) this.venueTrainingInstance.tags.push(tag);
    },

    removeTag(item) {
      this.venueTrainingInstance.tags.splice(this.venueTrainingInstance.tags.indexOf(item), 1);
    },

    updateStartDate: function (date) {
      this.localStartDate = date;

      this.constrainDates();
    },
    updateEndDate: function (date) {
      this.localEndDate = date;

      this.constrainDates();
    },
    constrainDates: function () {
      if (this.localStartDate !== null && this.localEndDate === null) {
        this.localEndDate = new Date(this.localStartDate);
        this.localEndDate.setHours(20);

        this.venueTrainingInstance.endDate = new Date(this.localEndDate);
      }

      if (this.localEndDate < this.localStartDate) {
        this.localEndDate = new Date(this.localStartDate);
        this.venueTrainingInstance.endDate = new Date(this.localEndDate);
      }
    },

    updateDuplicateStartDate: function (date) {
      this.localDuplicateStartDate = date;

      this.constrainDuplicateDates();
    },
    updateDuplicateEndDate: function (date) {
      this.localDuplicateEndDate = date;

      this.constrainDuplicateDates();
    },
    constrainDuplicateDates: function () {
      if (this.localDuplicateStartDate !== null && this.localDuplicateEndDate === null) {
        this.localDuplicateEndDate = new Date(this.localDuplicateStartDate);
        this.localDuplicateEndDate.setHours(20);

        this.duplicateEndDate = new Date(this.localDuplicateEndDate);
      }

      if (this.localDuplicateEndDate < this.localDuplicateStartDate) {
        this.localDuplicateEndDate = new Date(this.localDuplicateStartDate);
        this.duplicateEndDate = new Date(this.localDuplicateEndDate);
      }
    },

    getResponse: function (response) {
      return response.data;
    },
    onHit: function (item, vue /*, index*/) {
      let current = vue.current;
      let selectedItem = vue.data[current];

      this.venueTrainingInstance.instructorUserId = selectedItem.userId;
      this.venueTrainingInstance.instructorDisplayName = item;
    },
    highlighting: function (item, vue) {
      return item.toString().replace(vue.query, `<b>${vue.query}</b>`);
    },
    render: function (items /*, vue*/) {
      const titles = items.map(x => x.firstName + " " + x.lastName + " (" + x.email + ")");
      return titles;
    },
    fetch: function (/*url*/) {
      return this.$http.get(process.env.VUE_APP_API + "/users?query=" + this.data);
    },

    saveInfo: function () {
      this.$vs.loading({
        background: "primary",
        color: "#fff",
        container: "#save-button",
        scale: 0.45
      });

      const payload = {
        isActive: this.venueTrainingInstance.isActive,
        title: this.venueTrainingInstance.title,
        description: this.venueTrainingInstance.description,
        venueTrainingType: this.venueTrainingInstance.venueTrainingType,
        surveyLink: this.venueTrainingInstance.surveyLink,
        surveyDescription: this.venueTrainingInstance.surveyDescription,
        venueId: this.venueTrainingInstance.venueId,
        venueName: this.venueTrainingInstance.venueName,
        startDate: this.localStartDate,
        endDate: this.localEndDate,
        instructorId: this.venueTrainingInstance.instructorUserId,
        instructorDisplayName: this.venueTrainingInstance.instructorDisplayName,
        notificationMessage: this.venueTrainingInstance.notificationMessage,
        minParticipants: parseInt(this.venueTrainingInstance.minParticipants),
        maxParticipants: parseInt(this.venueTrainingInstance.maxParticipants),
        tags: this.venueTrainingInstance.tags,
        userQuery: this.venueTrainingInstance.userQuery
      };

      this.$http
        .put(process.env.VUE_APP_API + "/VenueTraining/" + this.venueTrainingInstance.id + "/info/general/", payload)
        .then((/*resp*/) => {
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Event saved"
          });
        })
        .catch(err => {
          console.log(err);

          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not save venue training: " + err
          });
        })
        .finally(() => {
          this.$vs.loading.close("#save-button > .con-vs-loading");
        });
    },
    showDuplicateVenueTrainingDialog: function () {
      this.duplicateStartDate = this.venueTrainingInstance.startDate;
      this.duplicateEndDate = this.venueTrainingInstance.endDate;

      this.activePromptDuplicateEvent = true;
    },
    duplicateVenueTraining: function () {
      this.$vs.loading();

      const payload = {
        masterVenueTrainingId: this.venueTrainingInstance.id,
        startDate: this.localDuplicateStartDate,
        endDate: this.localDuplicateEndDate
      };

      console.log("Duplicating venue training:", payload);

      this.$http
        .post(process.env.VUE_APP_API + "/VenueTrainings/duplicate", payload)
        .then(resp => {
          if (resp.data.success === true) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: "Event duplicated"
            });

            console.log(resp.data);

            this.$router
              .push({
                name: "admin-venue-training",
                params: {
                  venueTrainingId: resp.data.venueTrainingId
                }
              })
              .catch(() => {});
          } else {
            console.log(resp.data.error);

            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: "Could not duplicate event: " + resp.data.error
            });
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    refreshFromInstance: function (instance) {
      this.localStartDate = new Date(instance.startDate);
      this.localEndDate = new Date(instance.endDate);

      this.startDate = instance.startDate;
      this.endDate = instance.endDate;
    }
  },
  created() {
    this.venueTrainingId = this.$route.params.venueTrainingId;

    if (this.venueTrainingInstance !== null) {
      this.refreshFromInstance(this.venueTrainingInstance);
    }
  }
};
</script>

<style lang="scss">
.con-chips--remove-all {
  display: none;
}

.horizontal-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.typeahead-container input {
  padding: 0.7rem !important;
  font-size: 1rem !important;
  color: inherit;
  position: relative;
  padding: 0.4rem;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  width: 100%;
}

.instructor-chip {
  font-size: 14px;
}
</style>